<template>
    <NavBar color="#343A41" bgcolor="white">
        <template v-slot:title>
            <span class="nav-title">订单支付</span>
        </template>
    </NavBar>
    <div class="loading">
        <van-loading type="spinner" size="30" />
        <p>支付中...</p>
    </div>
</template>

<script src="./Page.js"></script>

<style src="./Page.scss" lang="scss" scoped></style>